namespace advisorop.components.advisor {

    export class AdvisorListAdvisorsController {
        $router;
     
        companyGroup: number;
        public advisors;
        onSelectedAdvisor: any;
        advisorSelected: domains.IAdvisor;
        public dg: DevExpress.ui.dxDataGridOptions; 
             

        user: domains.identity.IUser;

        static $inject = ["advisorService", "identityService", "generalService"];
        constructor(private advisorService: services.AdvisorService,
            private identityService: services.IdentityService,
            private generalService: services.GeneralService) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "Advisors"
                },
                bindingOptions: {
                    dataSource: "vm.advisors"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                //height: "350px",
                paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                //stateStoring: {
                //    enabled: true,
                //    type: "localStorage",
                //    storageKey: "dgAdvisorsSettings"
                //},
                columnChooser: {
                    enabled: true,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,              
                columns: [
                    { dataField: "fullName", caption: "Name", cellTemplate: "colFullName", width: 140 },
                    { dataField: "actions", caption: "Actions", cellTemplate: "btnActions", width: 210 },
                    { dataField: "repNumber", caption: "Rep Num.", width: 70 },
                    { dataField: "tinForPublic", caption: "TIN/SSN", width: 140, visible: false },
                    { dataField: "fullAddress", caption: "Address", width: 200, visible: false },
                    { dataField: "companyGroup.companyName", caption: "Firm", visible: false },
                    { dataField: "contactFullName", caption: "Contact", visible: false },
                    { dataField: "contactEmail", caption: "E-mail", visible: false },
                    { dataField: "systemLogin.username", caption: "Username", visible: true, width: 125 },                    
                    { dataField: "systemLogin.role", caption: "Role", visible: true, width: 110 },
                    { dataField: "systemLogin.loginStatusDesc", caption: "Login stat.", visible: true, width: 125 },
                    { dataField: "systemLogin.twoFactorEnabled", caption: "2FA", visible: true, width: 85, dataType: "boolean", cellTemplate: "colTwoFactor" },
                    { dataField: "systemLogin.ssoMode", caption: "Login Option", visible: true, width: 155, cellTemplate: "colSsoMode",
                      lookup: { dataSource: advisorop.identity.SsoModeOption.all(), valueExpr: 'value', displayExpr: 'label' } }
                ],
                //selection: {
                //    mode: "single",
                //    showCheckBoxesMode: "onClick"
                //},
                //onSelectionChanged: function (selectedItems) {
                //    var data = selectedItems.selectedRowsData[0];
                //    if (data) {
                //        this.vm.onAdvisorChanged({ id: data.id });
                //    }
                //}
            };
        }


        // /////////////////////////////////////////////////////////
        // Advisor system login methods

        enableSL(advisor: domains.IAdvisor): void {
            this.advisorService.enableAdvisorSL(advisor)
                .then((response) => {
                    //investor.systemLogin.loginStatus = 4;
                    //investor.systemLogin.loginStatusDesc = "SETUP";
                    advisor.systemLogin = (<domains.IInvestor>response.data).systemLogin;
                    toastr.success("Activation email sent to client at " + (<domains.IInvestor>response.data).contactEmail + ".");
                }, err => this.generalService.showError(err));
        };

        reactivateSL(advisor: domains.IAdvisor): void {
            this.advisorService.reactivateAdvisorSL(advisor)
                .then((response) => {
                    //investor.systemLogin.loginStatus = 4;
                    //investor.systemLogin.loginStatusDesc = "SETUP";
                    advisor.systemLogin = (<domains.IInvestor>response.data).systemLogin;
                    toastr.success("Reactivation email sent to client at " + (<domains.IInvestor>response.data).contactEmail + ".");
                }, err => this.generalService.showError(err));
        };

        disableSL(advisor: domains.IAdvisor): void {
            this.advisorService.disableAdvisorSL(advisor)
                .then(response => {
                    //investor.systemLogin.loginStatus = 3;
                    //investor.systemLogin.loginStatusDesc = "CANCELED";
                    advisor.systemLogin = (<domains.IInvestor>response.data).systemLogin;
                    toastr.success("User system login canceled.");
                }, err => this.generalService.showError(err));
        };

        lockSL(advisor: domains.IAdvisor): void {
            this.advisorService.lockAdvisorSL(advisor)
                .then(response => {
                    //investor.systemLogin.loginStatus = 2;
                    //investor.systemLogin.loginStatusDesc = "LOCKED";
                    advisor.systemLogin = (<domains.IInvestor>response.data).systemLogin;
                    toastr.success("User system login locked.");
                }, err => this.generalService.showError(err));
        };

        unlockSL(advisor: domains.IAdvisor): void {
            this.advisorService.unlockAdvisorSL(advisor)
                .then(response => {
                    advisor.systemLogin.loginStatus = 1;
                    advisor.systemLogin.loginStatusDesc = "ACTIVE";
                    toastr.success("User system login unlocked.");
                }, err => this.generalService.showError(err));
        }

        // Only an administrator may switch two-factor authentication off; the server enforces
        // this in IdentityService.SetTwoFactorEnabled, this only keeps the action out of the UI.
        isAdmin(): boolean {
            return (this.user && this.user.role == domains.AdvisoryRoles.ADVISORY_ADMIN.toString());
        }

        /// Only shown where the deployment actually has Salesforce sign-in. One build serves every
        /// client, so an ungated control would offer fifteen of them a sign-in method they do not
        /// have.
        ssoEnabled: boolean = false;
        ssoModes = advisorop.identity.SsoModeOption.all();

        ssoModeLabel(mode: number): string {
            return advisorop.identity.SsoModeOption.label(mode);
        }
        /// What the value was before the select was touched. ng-model has already changed the row
        /// by the time ng-change fires, so a cancelled confirmation or a failed save needs this to
        /// put it back rather than leave the screen claiming something the server never accepted.
        private ssoModeBefore: number = null;

        rememberSsoMode(advisor: domains.IAdvisor): void {
            // The setting lives on the login, not the advisor record.
            this.ssoModeBefore = advisor.systemLogin ? (advisor.systemLogin.ssoMode || 0) : 0;
        }

        /// Changes how this login may authenticate. The server records who did it.
        setSsoMode(advisor: domains.IAdvisor): void {
            if (!advisor.systemLogin) {
                return;
            }

            const mode = advisor.systemLogin.ssoMode;
            const previous = this.ssoModeBefore;

            if (mode === previous) {
                return;
            }

            if (!advisorop.identity.SsoModeOption.confirm(mode, advisor.fullName)) {
                advisor.systemLogin.ssoMode = previous;
                return;
            }

            this.advisorService.setSsoModeAdvisorSL(advisor, mode)
                .success((data) => {
                    angular.copy(data, advisor);
                    toastr.success(advisorop.identity.SsoModeOption.message(mode, advisor.fullName));
                })
                .error((data, status) => {
                    advisor.systemLogin.ssoMode = previous;
                    toastr.error("Error " + status + " " + data);
                });
        };

        setTwoFactor(advisor: domains.IAdvisor, enabled: boolean): void {
            // Off is always for a stated number of days; the enforcement job switches it back on
            // when they run out, so the administrator is told the date rather than left to
            // remember. See advisorop.identity.TwoFactorExemption for the wording and the range.
            let days: number = null;
            if (!enabled) {
                days = advisorop.identity.TwoFactorExemption.promptForDays(advisor.fullName);
                if (days === null)
                    return;
            }

            this.advisorService.setTwoFactorAdvisorSL(advisor, enabled, days)
                .then(response => {
                    advisor.systemLogin = (<domains.IAdvisor>response.data).systemLogin;
                    toastr.success(enabled
                        ? "Two-factor authentication turned on."
                        : advisorop.identity.TwoFactorExemption.offMessage(advisor.fullName, days));
                }, err => this.generalService.showError(err));
        }

        getAdvisorsForCurrentAdvisor(): void {
            this.advisorService.getAdvisorsForCurrentAdvisor()
                .then(response => {
                    this.advisors = response.data;
                }, err => this.generalService.showError(err));
        };

        selectedAdvisor(advisorId: number): void {
            //console.log();
            this.advisorService.getAdvisorById(advisorId)
                .then(data => {
                    this.advisorSelected = data.data;
                    this.onSelectedAdvisor({ advisor: this.advisorSelected })
                }).
                catch(error => {
                    toastr.error("Unable to get this advisor " + error.status + " " + error.data);
                })
        };
        

        $onInit(): void {
            this.identityService.getSsoConfig().then((response: any) => {
                this.ssoEnabled = !!(response.data && response.data.enabled);
            }, () => { this.ssoEnabled = false; });

            this.identityService.getUserPromise().then(response => {
                this.user = response;
            });
            this.getAdvisorsForCurrentAdvisor(); 
            
        }
        
    }
    
    class AdvisorListAdvisors implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router":"<",
                //companyGroup: "<",
                //onSelectedAdvisor: "&"
            };
            this.controller = AdvisorListAdvisorsController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/advisor-list-advisors.html";
        }
    }
    angular.module(Constants.APP).component("advisorListAdvisors", new AdvisorListAdvisors());

}